import { FC } from 'react';
import { Slide, ToastContainer } from 'react-toastify';

export const ToasterContainer: FC = () => {
  return (
    <ToastContainer
      position="bottom-left"
      closeButton={false}
      icon={false}
      transition={Slide}
      autoClose={3000}
      limit={1}
      data-testid="notification-snackbar"
    />
  );
};
